import { Route, Routes } from 'react-router-dom';
import {
  AboutPage,
  AddListingPage,
  AdminMessagesPage,
  AdminPage,
  ContactPage,
  Home,
  PrivacyPage,
  PropertyPage,
  RequestPage,
  Shop,
  WishlistPage,
} from './pages';
import { useTranslation } from 'react-i18next';

export const AppRoutes = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='properties' element={<Shop />} />
      <Route path='properties/:id' element={<PropertyPage />} />
      <Route path='add-listing' element={<AddListingPage />} />
      <Route path='admin' element={<AdminPage />}>
        <Route index path='messages' element={<AdminMessagesPage />} />
      </Route>
      <Route path='request-property' element={<RequestPage />} />
      <Route path='about' element={<AboutPage />} />
      <Route path='contact' element={<ContactPage />} />
      <Route path='wishlist' element={<WishlistPage />} />
      <Route path='privacy-policy' element={<PrivacyPage />} />
      <Route path='*' element={<div>{t('common.pageNotFound')}</div>} />
    </Routes>
  );
};
